import { SortingConfigTypes } from '../constants/ModelFamilyList';
import { GroupedOffers } from './groupOffers';

export const sortVehicleByModel = (offers: GroupedOffers, sortingConfig: SortingConfigTypes) => {
  const sortedObj: GroupedOffers = {};
  Object.entries(offers).forEach(([groupKey, groupValue]) => {
    const sortOrder = sortingConfig[groupKey];
    if (sortOrder) {
      sortedObj[groupKey] = Object.fromEntries(
        Object.entries(groupValue).sort((a, b) => {
          const indexA = sortOrder.indexOf(a[0]);
          const indexB = sortOrder.indexOf(b[0]);
          return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
        }),
      );
    } else {
      sortedObj[groupKey] = groupValue;
    }
  });
  return sortedObj;
};
